<template>
  <div>
    <ParentBar />
    <layout :isSuccess="true">
      <template v-slot:headZone>
        <headline :content="`${$t('area.area_history')} ${getArea(formData.areaId)?.name}`" />
        <v-col cols="12" class="container">
          <v-row class="area-history-search-container">
            <v-col>
              <v-select
                v-model="formData.dateType"
                :items="dateTypeList"
                :label="$t('select_date_type')"
                :placeholder="$t('select_date_type')"
                item-value="value"
                item-text="title"
                outlined
                dense
                hide-details
                :no-data-text="$t('noinfo')"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </template>
                <template v-slot:selection="{ item }">
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </template>
              </v-select>
            </v-col>
            <v-col cols="auto" class="flex-grow-1">
              <v-menu
                v-model="menuStartDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="$helper.datelabel(formData.startDate)"
                    :placeholder="$t('date')"
                    outlined
                    dense
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :label="$t('from_date')" />
                </template>
                <v-date-picker
                  v-model="formData.startDate"
                  no-title locale="th"
                  @input="menuStartDate = false"
                  :header-date-format="$helper.headerDateFormat"
                  :year-format="$helper.yearFormat"
                  :weekday-format="$helper.formatWeekday"
                  :month-format="$helper.formatMonth">
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="auto" class="flex-grow-1">
              <v-menu
                v-model="menuEndDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="$helper.datelabel(formData.endDate)"
                    :placeholder="$t('date')"
                    outlined
                    dense
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :label="$t('to_date')" />
                </template>
                <v-date-picker
                  v-model="formData.endDate"
                  no-title locale="th"
                  @input="menuEndDate = false"
                  :header-date-format="$helper.headerDateFormat"
                  :year-format="$helper.yearFormat"
                  :weekday-format="$helper.formatWeekday"
                  :month-format="$helper.formatMonth" />
              </v-menu>
            </v-col>
            <v-col>
              <v-select
                v-model="formData.selectCustomer"
                :items="customerList"
                :label="$t('customer.select_contractor_type')"
                :placeholder="$t('customer.select_contractor_type')"
                outlined
                dense
                hide-details
                item-value="value"
                item-text="title"
                :no-data-text="$t('noinfo')"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </template>
                <template v-slot:selection="{ item }">
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </template>
              </v-select>
            </v-col>
            <v-col cols="auto" class="flex-grow-0 search-history-btn">
              <v-btn
                @click="initData()"
                class="primary"
                :disabled="isLoading"
                :loading="isLoading"
              >
                <v-icon>mdi-magnify</v-icon>{{ $t('search') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </template>
      <template v-slot:containerZone>
        <v-data-table
          :loading="isLoading"
          :headers="headers"
          :items="items"
          :items-per-page="10"
          :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100] }"
          :no-data-text="$t('area.no_data_area_history')"
          :no-results-text="$t('area.no_data_area_history')"
          :sort-by="['checkedOutDate']"
          :sort-desc="[true]"
          class="data-table-resize-header"
        >
          <template v-slot:header.customerName="{ header }">
            <div class="text-nowrap-table text-center" style="min-width:300px">{{ header.text }}</div>
          </template>
          <template v-slot:body.prepend>
            <tr>
              <td></td>
              <td class="ps-0 type-filter">
                <v-select
                  v-model="filterData.type"
                  item-text="text"
                  item-value="value"
                  :items="filterOption.type"
                  type="text"
                  :label="$t('customer.customer_type')"
                  solo
                  dense
                  hide-details
                  clearable
                  :no-data-text="$t('noinfo')">
                </v-select>
              </td>
              <td></td>
              <td></td>
              <td class="ps-0 document-id-filter">
                <v-text-field
                  v-model="filterData.documentId"
                  type="text"
                  :label="`${$t('contract.contract_number_only')}/${$t('booking.booking')}`"
                  solo
                  dense
                  hide-details
                />
              </td>
              <td class="ps-0 customer-id-filter">
                <v-text-field
                  v-model="filterData.customerId"
                  type="text"
                  :label="$t('bill.customer_market_id')"
                  solo
                  dense
                  hide-details
                />
              </td>
              <td class="ps-0">
                <v-text-field
                  v-model="filterData.customerName"
                  type="text"
                  :label="$t('market.marchant_name')"
                  solo
                  dense
                  hide-details
                />
              </td>
            </tr>
          </template>
          <template v-slot:item.checkedOutDate="{ item }">
            {{ item.checkedOutDate ? $moment(item.checkedOutDate).format('DD/MM/YYYY') : '-' }}
          </template>
          <template v-slot:item.type="{ item }">
            <span :class="getTypeClass(item)">
              {{ item.type === 'daily' ? $t('daily') : $t('monthly') }}
            </span>
          </template>
          <template v-slot:item.startDate="{ item }">
            {{ item.startDate ? $moment(item.startDate).format('DD/MM/YYYY') : '-' }}
          </template>
          <template v-slot:item.endDate="{ item }">
            {{ item.endDate ? $moment(item.endDate).format('DD/MM/YYYY') : '-' }}
          </template>
          <template v-slot:item.documentId="{ item }">
            <div
              class="primary--text text-decoration-underline cursor-pointer"
              @click="item.booking ? openBookingDetail(item.booking) : openContractDetail(item.objectId)">
              {{ item.documentId }}
            </div>
          </template>
          <template v-slot:item.customerId="{ item }">
            {{ item.customerId }}
          </template>
          <template v-slot:item.customerName="{ item }">
            <div class="text-left text-truncate">
              {{ item.customerName }}
            </div>
          </template>
        </v-data-table>
      </template>
    </layout>
    <ContractDetailDialog
      v-model="contractDialog"
      :contractId="objectId"
      :show-area="true"
      :projectId="projectId"
      :marketId="marketId"
      :hideAreaHistoryButton="true">
    </ContractDetailDialog>
    <BookingDialog
      v-model="bookingDialog"
      :marketId="marketId"
      :projectId="projectId"
      :booking="booking"
      @setBooking="setBooking"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ContractDetailDialog from "../../components/ContractDetailDialog";
import BookingDialog from "../../components/BookingDialog";
import Layout from "../../components/Layout.vue";
import Headline from "../../components/Headline.vue";
import ParentBar from "@/components/ParentBar.vue";
import { AreaBooking, Contract } from "../../classes";
export default {
  components: {
    Layout,
    Headline,
    ParentBar,
    ContractDetailDialog,
    BookingDialog,
  },
  data() {
    return {
      isLoading: false,
      menuStartDate: false,
      menuEndDate: false,
      items: [],
      contractDialog: false,
      bookingDialog: false,
      booking: null,
      objectId: null,
      tempSelectCustomer: 'all',
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      dateTypeList: [
        {
          title: this.$t('area.checkout_date_area'),
          value: "checkedOutDate",
        },
        {
          title: this.$t('start_date'),
          value: "startDate",
        },
        {
          title: this.$t('end_date'),
          value: "endDate",
        },
      ],
      customerList: [
        {
          title: this.$t('all'),
          value: "all"
        },
        {
          title: this.$t('monthly'),
          value: "monthly"
        },
        {
          title: this.$t('daily'),
          value: "daily"
        }
      ],
      filterData: {
        type: '',
        documentId: '',
        customerId: '',
        customerName: '',
      },
      filterOption: {
        type: [],
      },
      formData: {
        areaId: this.$route.params.areaId,
        startDate: this.$moment()
          .subtract(1, 'year')
          .endOf('day') 
          .format('YYYY-MM-DD'),
        endDate: this.$moment()
          .endOf('day')
          .format('YYYY-MM-DD'),
        dateType: 'checkedOutDate',
        selectCustomer: 'all',
      },
    }
  },
  computed: {
    ...mapGetters({
      getAreaBookings: 'areaBooking/getAreaBookings',
      getContracts: 'contract/getContracts',
      getArea: 'area/getAreaById',
    }),
  },
  created() {
    this.headers = [
      {
        text: this.$t('area.checkout_date_area'),
        align: "center",
        value: "checkedOutDate",
        width: "100px"
      },
      {
        text: this.$t('customer.customer_type'),
        align: "center",
        value: "type",
        width: "100px",
        filter: d =>
            this.filterData.type
              ? d == this.filterData.type
              : d
      },
      {
        text: this.$t('start_date'),
        align: "center",
        value: "startDate",
        width: "100px",
      },
      {
        text: this.$t('end_date'),
        align: "center",
        value: "endDate",
        width: "100px",
      },
      {
        text: `${this.$t('contract.contract_number_only')}/${this.$t('booking.booking')}`,
        align: "center",
        value: "documentId",
        width: "200px",
        filter: (d) =>
            this.filterData.documentId
              ? d.toLowerCase().includes(this.filterData.documentId.toLowerCase())
              : d,
      },
      {
        text: this.$t('bill.customer_market_id'),
        align: "center",
        value: "customerId",
        width: "100px",
        filter: (d) =>
            this.filterData.customerId
              ? d.toLowerCase().includes(this.filterData.customerId.toLowerCase())
              : d,
      },
      {
        text: this.$t('market.marchant_name'),
        align: "center whitespace-nowrap text-truncate hd-resize",
        class: "whitespace-nowrap",
        value: "customerName",
        width: "1%",
        sortable: false,
        filter: (d) =>
            this.filterData.customerName
              ? d.toLowerCase().includes(this.filterData.customerName.toLowerCase())
              : d,
      },
    ];
    this.initData();
  },
  methods: {
    async initData() {
      this.isLoading = true;
      this.$store.commit("areaBooking/setAreaBookings", []);
      this.$store.commit("contract/setContracts", []);
      this.items = [];
      this.clearFilter();
      try {
        let limit = 100;
        let params = {
          areaId: this.formData.areaId,
          startDate: this.$moment(this.formData.startDate)
            .startOf("day")
            .toISOString(),
          endDate: this.$moment(this.formData.endDate)
            .endOf("day")
            .toISOString(),
          dateType: this.formData.dateType,
        }

        let areaBookings = [];
        let contracts = [];
        if (this.formData.selectCustomer === 'all') {
          this.filterOption.type = [
            { text: this.$t('daily'), value: 'daily' },
            { text: this.$t('monthly'), value: 'monthly' },
          ];
          [ areaBookings, contracts ] = await Promise.all([
            this.$helper.queryMore(
              AreaBooking.getAreaBookingHistoryByArea,
              params,
              limit,
            ),
            this.$helper.queryMore(
              Contract.getContractHistoryByArea,
              params,
              limit,
            )
          ])
        } else if (this.formData.selectCustomer === 'daily') {
          areaBookings = await this.$helper.queryMore(
            AreaBooking.getAreaBookingHistoryByArea,
            params,
            limit,
          )
        } else if (this.formData.selectCustomer === 'monthly') {
          contracts = await this.$helper.queryMore(
            Contract.getContractHistoryByArea,
            params,
            limit,
          )
        }
        this.$store.commit("areaBooking/setAreaBookings", areaBookings);
        this.$store.commit("contract/setContracts", contracts);
        this.prepareData();
        this.tempSelectCustomer = this.formData.selectCustomer;
        this.isLoading = false;
      } catch (error) {
        console.error(error)
        this.isLoading = false;
      }
    },
    prepareData() {
      const areaBookings = this.getAreaBookings || [];
      const contracts = this.getContracts || [];

      for (let areaBooking of areaBookings) {
        let fullName = this.buildFullNameInAreaBooking(areaBooking.booking.customer);
        this.items.push({
          checkedOutDate: areaBooking?.checkedOutDate?.iso,
          type: 'daily',
          startDate: areaBooking?.startDate?.iso,
          endDate: areaBooking?.endDate?.iso,
          documentId: areaBooking.booking.documentId,
          customerId: areaBooking.booking.customer.customerId,
          customerName: fullName,
          booking: areaBooking.booking,
        })
      }

      for (let contract of contracts) {
        this.items.push({
          checkedOutDate: contract?.closeContractAt?.iso,
          type: 'monthly',
          startDate: contract?.startDate?.iso,
          endDate: contract?.endDate?.iso,
          documentId: contract.contractId,
          customerId: contract.customer.customerId,
          customerName: contract.customer.fullName,
          objectId: contract.objectId,
        })
      }
    },
    setBooking(booking) {
      this.booking = booking;
    },
    buildFullNameInAreaBooking(customer) {
      let fullName = "";
      if (customer.type == "personal") {
        if (customer.title) fullName += customer.title + " ";
        if (customer.firstName) fullName += customer.firstName + " ";
        if (customer.lastName) fullName += customer.lastName;
      } else if (customer.type == "company") {
        if (customer.companyName) fullName += customer.companyName;
      }
      return fullName;
    },
    getTypeClass(item) {
      return item?.type === 'daily' ? 'daily-type' : 'monthly-type';
    },
    openContractDetail(contractId) {
      this.contractDialog = true;
      this.objectId = contractId;
    },
    openBookingDetail(booking) {
      this.bookingDialog = true;
      this.booking = booking;
    },
    clearFilter() {
      this.filterData = {
        type: '',
        documentId: '',
        customerId: '',
        customerName: '',
      };
      this.tempSelectCustomer = 'all';
    },
  }
}
</script>

<style scoped>
.container {
  background-color: white;
  display: flex;
  justify-content: center;
}

.area-history-search-container {
  display: flex;
  flex-wrap: nowrap;
  background-color: white;
  max-height: 80px;
  min-width: auto;
  max-width: 1800px;

  .v-select {
    max-width: 300px;
    min-width: auto;
  }

  .search-history-btn {
    min-width: 100px;
  }
}

.daily-type {
  color: #029CE5;
}

.monthly-type {
  color: #000000;
}

.type-filter, .customer-id-filter {
  max-width: 100px;
  min-width: 100px;
}

.document-id-filter {
  max-width: 200px;
  min-width: 200px;
}

.data-table-resize-header::v-deep th.custom-sort {
  position: relative;

  .v-icon {
    position: absolute;
    right: 10px;
    top: 15px;
  }
}

.data-table-resize-header::v-deep td.hd-resize {
  max-width: 100px;
  &.meter-name{
    max-width: 190px; 
  }
}
</style>
